export default __webpack_public_path__ + "media/images/icons_fc/clock3-de491b46cdbc1b264ec8866533cb218e.png";